//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    opened: {
      type: Boolean
    },
    message: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: null
    },
    blocked: {
      type: Boolean,
      default: null
    }
  },
  watch: {
    opened: function (val) {
      if (val & !this.blocked) {
        setTimeout(this.close, 3000)
      }
    }
  },
  methods: {
    close: function () {
      this.$emit('closeDialog')
    }
  }
}

